















export default

	props: product: Object

	computed:

		count: -> @product.reviewsCount?.value
		avg: -> @product.reviewsAverage?.value
		percentage: -> "#{@avg/5*100}%"

		label: -> "Rated #{@avg} out of 5 by #{@count} reviewers."

